import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "home" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GlitchH1 = _resolveComponent("GlitchH1")!
  const _component_GlitchP = _resolveComponent("GlitchP")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_GlitchH1, { glitch: _ctx.glitch1 }, {
      default: _withCtx(() => _cache[0] || (_cache[0] = [
        _createTextVNode("Erikdevelop.com")
      ])),
      _: 1,
      __: [0]
    }, 8, ["glitch"]),
    _createVNode(_component_GlitchP, { glitch: _ctx.glitch2 }, {
      default: _withCtx(() => _cache[1] || (_cache[1] = [
        _createTextVNode("Under construction...")
      ])),
      _: 1,
      __: [1]
    }, 8, ["glitch"]),
    _createVNode(_component_GlitchP, { glitch: _ctx.glitch3 }, {
      default: _withCtx(() => _cache[2] || (_cache[2] = [
        _createTextVNode(" even in the sunnier world of vue, rewriting your entire codebase isn't out of the question because an NPM package decided to shit the bed... ")
      ])),
      _: 1,
      __: [2]
    }, 8, ["glitch"]),
    _createVNode(_component_GlitchP, { glitch: _ctx.glitch4 }, {
      default: _withCtx(() => _cache[3] || (_cache[3] = [
        _createTextVNode("Besides, I learned, and got better...")
      ])),
      _: 1,
      __: [3]
    }, 8, ["glitch"]),
    _createVNode(_component_GlitchP, { glitch: _ctx.glitch5 }, {
      default: _withCtx(() => _cache[4] || (_cache[4] = [
        _createTextVNode(" Nope, never mind, Vue comes with 4 critical vulnerabilities out of the box. ")
      ])),
      _: 1,
      __: [4]
    }, 8, ["glitch"])
  ]))
}